import React from 'react';

var Context = /*#__PURE__*/React.createContext({
  primaryColor: "#124fa0",
  fontSize: 14,
  warningColor: "#f44336",
  disabledColor: "#ddd"
});

export { Context as C };
